import {
  clearStrataZeitroAuthCookies,
  syncLoSessionToStrataCookieIfMissing,
} from "../syncStrataSession.js";
// import MortgageGPT from "./MortgageGPT";
import { useLocation } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { track } from "statsig";
import { STATSIG, PAGE } from "statsig/events";
import { getEnvironment } from "../Common";

// const AI_TYPES = ["CLASSIC", "NEW"];
// const AI_TYPE_STORAGE_KEY = "mortgage_gpt_ai_type";

// Strata 地址按环境选，不按域名后缀：白标客户的贷款发起系统跑在客户自己的域名上
// （agent.zendomtg.ai、www.swang.loan 等），getEnvironment() 把它们都算生产。
// getEnvironment() 把 *.zeitro.net（dev 环境）和本机开发都算 development，这里再按主机分开。
function getStrataBaseUrl() {
  const environment = getEnvironment();
  if (environment === "production") {
    return "https://www.zeitro.com";
  }
  if (environment === "staging") {
    return "https://www.zeitro.us";
  }
  const hostname = window.location.hostname || "";
  if (hostname.endsWith(".zeitro.net")) {
    return "https://www.zeitro.net";
  }
  return "http://localhost:3001";
}

export function getStrataIframeSrc() {
  syncLoSessionToStrataCookieIfMissing();

  const baseUrl = getStrataBaseUrl();
  const { pathname } = window.location;
  const SHOW_LOGOUT = pathname.includes("guidelinegpt");
  // workflow 模式（/guidelinegpt/workflow/:customerid）：Strata 通过路径 /strata/ai/:customerid 识别 customer。
  // 若不带该路径，Strata 的 Customer 请求头为空，后端会回退到 default guideline 配置（而非用户配置过的 guideline）。
  const customerId = pathname.includes("/workflow/")
    ? pathname.split("/workflow/")[1]?.split("/")[0]
    : "";
  const workflowPath = customerId ? `ai/${customerId}` : "";

  const token = sessionStorage.getItem("ZeitroA");
  const setToken = token ? `&a=${sessionStorage.getItem("ZeitroA")}` : ""; // 有些用户有专属的二级域名

  return `${baseUrl}/strata/${workflowPath}?embedded=1${SHOW_LOGOUT ? "&show_logout=1" : ""}${setToken}`;
}

// function getInitialAIType() {
//   const cachedType = sessionStorage.getItem(AI_TYPE_STORAGE_KEY);

//   return AI_TYPES.includes(cachedType) ? cachedType : "NEW";
// }

// const AI = ({ hideBackButton, fromLanding }) => {
//   const [type, setType] = useState(getInitialAIType); // CLASSIC 、NEW
//   const isNewAi = type === "NEW";

//   function onAIChange(type) {
//     if (!AI_TYPES.includes(type)) return;
//     sessionStorage.setItem(AI_TYPE_STORAGE_KEY, type);
//     setType(type);
//   }

//   useEffect(() => {
//     function handleMessage(event) {
//       switch (event.data?.type) {
//         case "MAI_LOGOUT":
//           // Strata iframe 内点击退出后，父页面同步清理 LO/Strata 登录态并整页刷新。
//           window.sessionStorage.removeItem("ZeitroA");
//           clearStrataZeitroAuthCookies();
//           window.location.reload();
//           return;
//         case "MAI_AI_SWITCH_CHANGE":
//           // 切换AI
//           if (!AI_TYPES.includes(event.data.value)) return;
//           onAIChange(event.data.value);
//           return;
//         default:
//           return;
//       }
//     }

//     window.addEventListener("message", handleMessage);
//     return () => {
//       window.removeEventListener("message", handleMessage);
//     };
//   }, []);

//   useEffect(() => {
//     if (isNewAi) {
//       syncLoSessionToStrataCookieIfMissing();
//     }
//   }, [isNewAi]);

//   return !isNewAi ? (
//     <MortgageGPT
//       onAIChange={onAIChange}
//       fromLanding={fromLanding}
//       hideBackButton={hideBackButton}
//     />
//   ) : (
//     <iframe
//       src={getStrataIframeSrc()}
//       title="Strata"
//       frameBorder="0"
//       style={{
//         inset: 0,
//         border: 0,
//         width: "100%",
//         height: "100vh",
//         display: "block",
//       }}
//     />
//   );
// };

// export default AI;

const AI = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);

  useEffect(() => {
    track(STATSIG.COMMON.VIEW, PAGE.STRATA_AI, { page: PAGE.STRATA_AI });
  }, []);

  useEffect(() => {
    function handleMessage(event) {
      switch (event.data?.type) {
        case "MAI_LOGOUT":
          // Strata iframe 内点击退出后，父页面同步清理 LO/Strata 登录态并整页刷新。
          window.sessionStorage.removeItem("ZeitroA");
          clearStrataZeitroAuthCookies();
          window.location.reload();
          return;
        default:
          return;
      }
    }

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 576);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const URL_STRATA = useMemo(() => {
    return getStrataIframeSrc();
  }, []);

  return (
    <iframe
      src={URL_STRATA}
      title="Strata"
      frameBorder="0"
      style={{
        inset: 0,
        border: 0,
        width: "100%",
        height: isMobile ? "calc(100vh - 66px)" : "100vh",
        display: "block",
      }}
    />
  );
};

export default AI;
